'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require('ramda');

var _card_component = require('./global_components/card_component');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component');

var _table_component2 = _interopRequireDefault(_table_component);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility = require('common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var ExchangesCard = function (_React$PureComponent) {
  _inherits(ExchangesCard, _React$PureComponent);

  function ExchangesCard(props) {
    _classCallCheck(this, ExchangesCard);

    return _possibleConstructorReturn(this, (ExchangesCard.__proto__ || Object.getPrototypeOf(ExchangesCard)).call(this, props));
  }

  _createClass(ExchangesCard, [{
    key: 'renderListOfExchangesHeaderRow',
    value: function renderListOfExchangesHeaderRow() {
      var headerRow = [];
      var headerRowLabels = [_string_utility2.default.renderFormattedLabel('Exchange', 'pdp-overview-exchanges-exchange'), _string_utility2.default.renderFormattedLabel('Ticker', 'pdp-overview-exchanges-ticker'), _string_utility2.default.renderFormattedLabel('Ccy', 'pdp-overview-exchanges-ccy'), _string_utility2.default.renderFormattedLabel('Listing date', 'pdp-overview-exchanges-listing-date'), _string_utility2.default.renderFormattedLabel('SEDOL', 'pdp-overview-exchanges-sedol'), _string_utility2.default.renderFormattedLabel('BBG Ticker', 'pdp-overview-exchanges-bbg-ticker'), _string_utility2.default.renderFormattedLabel('RIC', 'pdp-overview-exchanges-ric')];

      _collection_utility.CollectionUtility.forEachIndexed(headerRowLabels, function (label, index) {
        headerRow.push(_react2.default.createElement(
          'td',
          { key: index, 'data-testid': 'exchanges-table-header',
            className: 'white-space-nowrap' },
          label
        ));
      });
      return headerRow;
    }
  }, {
    key: 'renderCol',
    value: function renderCol(value, dataTest) {
      return _react2.default.createElement(
        'td',
        { className: 'margin-top-5', 'data-testId': dataTest },
        _string_utility2.default.displayValue(value)
      );
    }
  }, {
    key: 'renderFormattedDate',
    value: function renderFormattedDate(inputDate) {
      return _date_formatter2.default.isValidDate(inputDate) ? _date_formatter2.default.getLocalFormattedDate(inputDate) : "-";
    }
  }, {
    key: 'renderListOfExchangesTableRows',
    value: function renderListOfExchangesTableRows() {
      var _this2 = this;

      return mapIndexed(function (row, index) {
        if (!(0, _functional_utility.isNilOrEmpty)(row.tradingLineListingDate)) {
          return _react2.default.createElement(
            'tr',
            { key: index,
              className: 'category row-divider',
              'data-testId': 'exchange-row' },
            _this2.renderCol(row.tradingLineName, 'exchanges-exchange-row-' + index),
            _this2.renderCol(row.exchangeTickerCode, 'exchanges-ticker-row-' + index),
            _this2.renderCol(row.tradingCurrencyCode, 'exchanges-ccy-row-' + index),
            _this2.renderCol(_this2.renderFormattedDate(row.tradingLineListingDate), 'exchanges-listing-date-row-' + index),
            _this2.renderCol(row.stockExchangeDailyOfficialListCode, 'exchanges-sedol-row-' + index),
            _this2.renderCol(row.tradingLineBloombergTickerCode, 'exchanges-bbg-ticker-row-' + index),
            _this2.renderCol(row.reutersIdentificationCode, 'exchanges-ric-row-' + index)
          );
        }
      }, this.props.data);
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.data) || (0, _ramda.length)(this.props.data) < 1) {
        return null;
      }
      var tableRows = this.renderListOfExchangesTableRows();
      if ((0, _ramda.isNil)(tableRows) || tableRows.every(function (item) {
        return item === undefined;
      })) {
        return null;
      }
      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: 'exchanges',
          headerTitle: _string_utility2.default.renderFormattedLabel('List of exchanges', "pdp-overview-exchanges-header-label"),
          headerTitleId: 'exchanges-title',
          breakpoint: this.props.breakpoint,
          disclosureText: (0, _ramda.pathOr)(null, ["disclosures", "pdpCardListofExchanges"], this.props),
          placementId: "pdpCardListofExchanges"
        },
        _react2.default.createElement(_table_component2.default, {
          tableHeaders: this.renderListOfExchangesHeaderRow(),
          tableRows: tableRows,
          tableBodyTest: 'exchanges-table-body',
          activeTab: this.props.activeTab,
          breakpoint: this.props.breakpoint
        })
      );
    }
  }]);

  return ExchangesCard;
}(_react2.default.PureComponent);

exports.default = ExchangesCard;